// extracted by mini-css-extract-plugin
module.exports = {"arrowUp":"TableColumnHeader_arrowUp__2HAKO","arrowDown":"TableColumnHeader_arrowDown__HeYFk","dummy":"TableColumnHeader_dummy__3VUDp"};